module.exports = __webpack_public_path__ + "img/ic_logo.8c374ca5.svg";